class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const portaledSheet = event.target.closest?.('.bambu-search-portal > [data-global-bottom-sheet]');
    const isInsideOwnedPortal = portaledSheet?.globalBottomSheet?.owner === this;
    const isOverlayClick = event.target.classList.contains('modal-overlay');

    if ((!this.contains(event.target) && !isInsideOwnedPortal) || isOverlayClick) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    /* Only the search modal draws a full scrim; the other details-modals are
       small dropdowns where a follow cursor would have nothing to track over. */
    if (window.FilazooPopup && this.classList.contains('bambu-search-modal')) {
      window.FilazooPopup.activate(this, () => this.close());
    }
  }

  close(focusToggle = true) {
    if (window.FilazooPopup) window.FilazooPopup.deactivate(this);
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
